import pencil from 'src/assets/icons/icon-pencil.svg';

interface PencilProps {
  onClick: React.MouseEventHandler<HTMLSpanElement>;
  className?: string;
}

export const Pencil: React.FC<PencilProps> = ({ onClick, className }) => (
  <span className={`edit-icon me-4 cursor-pointer ${className}`} onClick={onClick}>
    <img src={pencil} alt="pencil" />
  </span>
);
